export default "__VITE_ASSET__BSHMOA7H__"